import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

import AuthRoute from './auth';
import UserRoute from './user';
import OrderRoute from './order';
import ReturnRoute from './return';
import FattureincloudRoute from './fattureincloud';
import ArubaRoute from './aruba';
import ShippingRoute from './shipping';
import CategoryRoute from './category';
import BrandRoute from './brand';
import BrandImportRoute from './brandimport';
import CompetitorRoute from './competitor';
import ItemRoute from './items';
import RiordinoRoute from './riordinos';
import InventoryRoute from './inventories';
import AmazonRoute from './amazon';
import EbayRoute from './ebay';
import SettingRoute from './setting';
import ListingsRoute from './listings';
import AttributeRoute from './attribute';
import VariantRoute from './variant';
import OrderSuppliersRoute from './order_suppliers';
import SuppliersRoute from './supplier';
import CustomerRoute from './customer';
import AgentRoute from './agent';
import TagRoute from './tag';
import NotifyRoute from './notify';
import SnapshotRoute from './snapshot';
import PackingListRoute from './packing_list';
import DispatchOrdersRoute from './dispatch_orders';
import MessagesRoute from './messages';
import DocumentsRoute from './documents';
import EcommerceRoute from './ecommerce';
import BoughtRoute from './boughts';
import WarehouseRoute from './warehouse';
import NewsletterRoute from './newsletter';
import CartRoute from './cart';
import CommunicationRoute from './communication';
import AssistantRoute from './assistant';
import WhatsappRoute from './whatsapp';
import StatsRoute from './stats';
import AnalyticsRoute from './analytics';
import ReportRoute from './report';
import AffiliateRoute from './affiliate';
import PartnerProgramRoute from './partnerprogram';
import AffiliateProgramRoute from './affiliateprogram';
import ManageRoute from './manage';
import GiftCardRoute from './giftcard';
import FlyersRoute from './flyers';
import SocialPostsRoute from './socialposts';
import AlertsRoute from './alerts';
import RedirectsRoute from './redirects';
import ReviewsRoute from './reviews';
import SearchLogsRoute from './searchlogs';
import WebVitalsRoute from './webvitals';
import ServerHealthRoute from './serverhealth';
import SiteHealthRoute from './sitehealth';
import CatalogCheckRoute from './catalogcheck';
import InsightsRoute from './insights';
import FinanceRoute from './finance';
import AdsRoute from './ads';
import TasksRoute from './tasks';
import TicketsRoute from './tickets';

import { checkauth } from '../Helper';
import axios from 'axios';
import store from '../store';
import Expired from '@/views/Expired.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'intro',
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (!response) {
					next('/login');
				} else {
					next('/home');
				}
			});
		},
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (!response) {
					next('/login');
				} else {
					next();
				}
			});
		},
	},
	{
		path: '/expired',
		name: 'expired',
		component: Expired,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (!response) {
					next('/login');
				} else {
					next();
				}
			});
		},
	},
	...AuthRoute,
	...UserRoute,
	...OrderRoute,
	...CategoryRoute,
	...BrandRoute,
	...BrandImportRoute,
	...CompetitorRoute,
	...SettingRoute,
	...AttributeRoute,
	...VariantRoute,
	...ItemRoute,
	...OrderSuppliersRoute,
	...SuppliersRoute,
	...ListingsRoute,
	...CustomerRoute,
	...AgentRoute,
	...ShippingRoute,
	...TagRoute,
	...NotifyRoute,
	...SnapshotRoute,
	...FattureincloudRoute,
	...ArubaRoute,
	...AmazonRoute,
	...PackingListRoute,
	...DispatchOrdersRoute,
	...MessagesRoute,
	...DocumentsRoute,
	...EbayRoute,
	...EcommerceRoute,
	...InventoryRoute,
	...BoughtRoute,
	...WarehouseRoute,
	...RiordinoRoute,
	...NewsletterRoute,
	...CartRoute,
	...CommunicationRoute,
	...ReturnRoute,
	...StatsRoute,
	...AnalyticsRoute,
	...ReportRoute,
	...AssistantRoute,
	...WhatsappRoute,
	...AffiliateRoute,
	...PartnerProgramRoute,
	...AffiliateProgramRoute,
	...ManageRoute,
	...GiftCardRoute,
	...FlyersRoute,
	...SocialPostsRoute,
	...AlertsRoute,
	...RedirectsRoute,
	...ReviewsRoute,
	...SearchLogsRoute,
	...WebVitalsRoute,
	...ServerHealthRoute,
	...SiteHealthRoute,
	...CatalogCheckRoute,
	...InsightsRoute,
	...FinanceRoute,
	...AdsRoute,
	...TasksRoute,
	...TicketsRoute,
];

const router = new VueRouter({
	routes,
});

// stesso bundle servito su piu' host: le aree riservate si riconoscono dall'hostname e ognuna
// vive su una sola rotta
const PARTNER_HOSTS = ['partner.azseller.app', 'devpartner.azseller.app'];
const AFFILIATE_HOSTS = ['affiliate.azseller.app', 'devaffiliate.azseller.app'];
const currentHost = () => (typeof window !== 'undefined' ? window.location.hostname : '');
const isStandaloneHost = () => PARTNER_HOSTS.includes(currentHost()) || AFFILIATE_HOSTS.includes(currentHost());

router.beforeEach((to, from, next) => {
	if (PARTNER_HOSTS.includes(currentHost()) && to.path !== '/partnerprogram') {
		return next('/partnerprogram');
	}
	if (AFFILIATE_HOSTS.includes(currentHost()) && to.path !== '/affiliateprogram') {
		return next('/affiliateprogram');
	}
	next();
});

router.afterEach((to, from) => {
	// sulle aree riservate non esiste un token BO: `fetchLicense` prenderebbe 401 a ogni navigazione
	if (isStandaloneHost()) {
		return;
	}
	// le pagine pubbliche (login e recupero password) non hanno una sessione BO
	if (!['/login', '/forgot-password', '/reset-password'].includes(to.path)) {
		store.dispatch('profile/fetchLicense');
	}
});

export default router;
